import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// /partner/join — the address of partner links and ads. There is one sign-up for everybody: a new
// person registers (the page then sends them to the settings, where the application is filed once the
// email is confirmed), a signed-in one goes straight to the settings.
const PartnerJoinPage = () => {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/settings' : '/register?partner=1'} replace />;
};

export default PartnerJoinPage;
